import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';
import {
  getCertificateContracts,
  getEligibleContracts,
  getGroupCertificates,
  getGroupZeroCarbonProjects,
  getGroupZeroCarbonStatistics,
  getLinkedContracts,
} from '~/services/GroupZeroCarbon';
import { Pagination, SelectItem } from '~/types';
import {
  AttachCertificateDetails,
  AttachCertificateDetailsView,
  CertificateContracts,
  EligibleContract,
  GroupZeroCarbonCartificateView,
  GroupZeroCarbonStatisticsView,
  PreviewAddContractView,
  ZeroCarbonProject,
  ZeroCarbonProjectView,
} from '~/types/zeroCarbon';

export function useEligibleContracts(
  id: string,
  options: UseQueryOptions<Pagination<EligibleContract>> = {},
): UseQueryResult<Pagination<EligibleContract>> {
  return useQuery<Pagination<EligibleContract>>(
    ['eligible_contracts', id],
    () => getEligibleContracts(id),
    {
      staleTime: 1000 * 60 * 10, // 10 minutes
      ...options,
    },
  );
}

export function useGroupZeroCarbonProjects(
  options: UseQueryOptions<ZeroCarbonProjectView[]> = {},
): UseQueryResult<ZeroCarbonProjectView[]> {
  return useQuery<ZeroCarbonProjectView[]>(
    'group_zero_carbon_projects',
    getGroupZeroCarbonProjects,
    {
      staleTime: 1000 * 60 * 10, // 10 minutes
      ...options,
    },
  );
}

export function useGroupCertificatesZeroCarbon(
  id: string,
  options: UseQueryOptions<Pagination<GroupZeroCarbonCartificateView>> = {},
): UseQueryResult<Pagination<GroupZeroCarbonCartificateView>> {
  return useQuery<Pagination<GroupZeroCarbonCartificateView>>(
    ['group_certificates_zero_carbon', id],
    () => getGroupCertificates(id),
    {
      staleTime: 1000 * 60 * 10, // 10 minutes
      ...options,
    },
  );
}

export function useGroupZeroCarbonStatistics(
  id: string,
  options: UseQueryOptions<GroupZeroCarbonStatisticsView> = {},
): UseQueryResult<GroupZeroCarbonStatisticsView> {
  return useQuery<GroupZeroCarbonStatisticsView>(
    ['group_zero_carbon_statistics', id],
    () => getGroupZeroCarbonStatistics(id),
    {
      ...options,
    },
  );
}

export function useCertificateContracts(
  id: string,
  options: UseQueryOptions<CertificateContracts[]> = {},
): UseQueryResult<CertificateContracts[]> {
  return useQuery<CertificateContracts[]>(
    ['certificate_contracts', id],
    () => getCertificateContracts(id),
    {
      staleTime: 1000 * 60 * 10, // 10 minutes
      ...options,
    },
  );
}

export function useLinkedContracts(
  id: string,
  options: UseQueryOptions<AttachCertificateDetailsView> = {},
): UseQueryResult<AttachCertificateDetailsView> {
  return useQuery<AttachCertificateDetailsView>(
    ['linked_contracts', id],
    () => getLinkedContracts(id),
    {
      staleTime: 1000 * 60 * 10, // 10 minutes
      ...options,
    },
  );
}
